import { TabContentItem } from './TabContentItem'
import { TabNavigationItem } from './TabNavigationItem'
import { TabsNavigation, TabsWrapper } from './Tabs'
import { TabsContent } from './TabsContent'

export const Tabs = {
  ContentItem: TabContentItem,
  NavigationItem: TabNavigationItem,
  Wrapper: TabsWrapper,
  Navigation: TabsNavigation,
  Content: TabsContent,
}
